import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logo from './viident-logo-transparent.png';

function Videographer() {
  return (
    <div className="App">
            <div className="App-main">
                <img src={logo} className="App-logo" alt="logo" />
                <p className="App-main-text">
                    Videographer
                </p>

                <p>Viident Publishing Inc.<br/>
                Cincinnati/Northern Kentucky<br/>
                Full-Time</p>

                <br/>

                <h3>About the Role</h3>

                <p> Are you a creator or storyteller?<br/><br/>

Do you love video visuals to a concerning level?<br/><br/>

Do you find great joy in creating content that truly inspires?<br/><br/>

If this sounds like you, this could be an awesome fit…<br/><br/>

This is videography.<br/><br/>
This is content creation.<br/><br/>
This is filming and editing and cutting and storytelling and more.<br/><br/>
But it’s videography with a small, unique publishing company built by entrepreneurial thought leader, public speaker, and New York Times bestselling author, Matthew Kelly. (Curious? Check out his YouTube channel!)
                </p>

                <br/>
                <br/>

                <h4>We'll spell it out clearly:</h4>
                <p>
                    You’ll work directly under Matthew to support and enhance his vast YouTube and social media presence. Branding and mission is everything!
                    <br/><br/>
                    You’ll be in and out of Viident’s private studio to film videos for YouTube and our ministry, along with Matthew Kelly interviews. You’ll have access to world-class equipment, so no pressure.
                    <br/><br/>
                    You’ll produce, edit, rework, and rework again all video content. You’ll ensure titles, thumbnails, and descriptions are correct and on-brand. You’ll be the unsung hero behind it all!
                    <br/><br/>
                    Additionally, you’ll record and edit audiobooks as needed, reviewing files, requesting edits, and collaborating with authors and narrators.
                    <br/><br/>
                    Content creation isn’t as easy as it may seem, but it’s so worth it. We hit hard deadlines and pivot onto new projects in the blink of an eye. You’ll have to be efficient and creative while under stress. You’ll have to be accurate and consistent in caring for a vast YouTube channel.
                    <br/><br/>
                    If you gulped while reading that – move on. If you’re thinking, I love a good challenge and I’m not afraid to get the work done, keep reading!
                </p>
                
                <p>Viident creates content that helps people become the-best-version-of-themselves. If you are a qualified candidate interested in getting paid to grow professionally, make a difference, add tremendous value to our team, and change lives, we look forward to hearing from you.</p>
                
                <p>The position is a Monday-Friday in-office role, occasionally requiring availability outside of normal business hours.</p>

                <br/>

                <h4>Compensation Package:</h4>
                <p>Salary $50,000 to $60,000 + Full Health Care Benefits + 3% 401k Match</p>
                <p>Job Type: Full-Time</p>
                <p>Pay: $50,000.00 - $60,000.00 per year</p>
                <p>Benefits: 401(k) matching, Health Insurance</p>
                <p>Schedule: Monday to Friday</p>
                <p>Work Location: In person</p>

                <h4>If you are interested, please email your cover letter and resume to careers@viident.com.</h4>
            </div>
            <br/>
            <br/>
            <footer className="App-footer">
              <br/>
              <Link to="/careers" className="App-link">Back to Careers</Link>
              <br/>
              <p className="quote-text">
                "Books change our lives, because we become the books we read."
              </p>
              <p>
                Matthew Kelly
              </p>
            </footer>
    </div>
  );
}

export default Videographer;